module.exports = __webpack_public_path__ + "static/media/ManyBuildWhite.3f100058.png";